/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import Text from "../../ui/Text";
import Flex from "../../ui/Flex";
import Stack from "../../ui/Stack";
import ProductGrid from "./ProductGrid";
import { usePreparedProductsForService } from "../../../hooks/usePreparedProductsForService";

const REVEAL_STEP = 10;

const ServiceProductsCard = ({ service, handleProductSelect, updateProduct, addDefaultProducts }) => {
  const { products, totalCount, isLoading } =
    usePreparedProductsForService(service, { addDefaultProducts });
  const [visibleCount, setVisibleCount] = useState(REVEAL_STEP);

  const hasProducts = service.has_available_products && (isLoading || totalCount > 0);
  if (!hasProducts) return null;

  return (
    <Stack $gap="0.5rem">
      <Flex $gap="0.3rem">
        <Text style={{ textWrapMode: "nowrap" }}>{`For service`}</Text>
        <Text color="dark" weight="bold">{service.name}</Text>
      </Flex>

      <ProductGrid
        products={products.slice(0, visibleCount)}
        isLoading={isLoading}
        hasNextPage={products.length > visibleCount}
        onLoadMore={() => setVisibleCount((count) => count + REVEAL_STEP)}
        position={service.id}
        selectedProducts={service.products}
        handleProductSelect={handleProductSelect}
        updateProduct={updateProduct}
      />
    </Stack>
  );
};

export default ServiceProductsCard;